import React, { useContext, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import { useParams } from "react-router-dom";
import HeaderBanner from "../Components/HeaderBanner";
import Config from "../config.json";
import ComponentContext from "../Context";
import Kargah from "../Images/kargah.png";
import Statics from "../Statics";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | ثبت نام کارگاه",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

const WorkShopRegister = () => {
  const { workshop_id } = useParams();

  const context = useContext(ComponentContext);

  const [workshop, set_workshop] = useState(null);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [form_first_name, set_form_first_name] = useState(
    context.profile ? context.profile.first_name : "",
  );
  const [form_last_name, set_form_last_name] = useState(
    context.profile ? context.profile.last_name : "",
  );
  const [form_id_number, set_id_number] = useState("");
  const [form_grade, set_form_grade] = useState("");
  const [form_field, set_form_field] = useState("");
  const [form_university, set_form_university] = useState("");
  const [form_email, set_form_email] = useState("");
  const [form_phone, set_form_phone] = useState("");
  const [form_address, set_form_address] = useState("");
  const [form_job, set_form_job] = useState("");
  const [form_birth_date_year, set_form_birth_date_year] = useState("0");
  const [form_birth_date_month, set_form_birth_date_month] = useState("0");
  const [form_birth_date_day, set_form_birth_date_day] = useState("0");
  const [requesting, set_requesting] = useState(false);

  const getWorkshop = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.searchWorkshops(
      { workshop_id },
      (data, meta) => {
        set_workshop(data.data[0]);
        set_loading_state(Statics.LOADED);
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };

  const registerWorkShop = () => {
    set_requesting(true);
    const formData = {};
    formData.first_name = form_first_name;
    formData.last_name = form_last_name;
    formData.id_number = form_id_number;
    formData.job = form_job;
    formData.grade = form_grade;
    formData.field = form_field;
    formData.university = form_university;
    formData.email = form_email;
    formData.phone = form_phone;
    formData.address = form_address;
    formData.birth_date =
      form_birth_date_year +
      "-" +
      form_birth_date_month +
      "-" +
      form_birth_date_day;
    formData.workshop_id = workshop_id;
    context.ApiDriver.registerInWorkshop(
      formData,
      (data, meta) => {
        set_requesting(false);
        window.location = `/workshop/register/detail/${data.register_request_id}`;
      },
      error => {
        set_requesting(false);
        for (const err in error.response.data) {
          const element = document.getElementById(
            error.response.data[err].field,
          );
          if (element) {
            element.className += " invalid-forminput";
          }
        }
        // for (let err in error.response.data) {
        //   context.notification(error.response.data[err].message, "error");
        // }
      },
    );
  };

  if (loading_state === Statics.NOT_LOADED) {
    getWorkshop();
  }

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />
      {loading_state === Statics.LOADED && workshop ? (
        <Row className="mx-0 fdfdf" style={{ padding: "50px 30px" }}>
          <Col>
            <Row className="workshop-details mx-0 justify-content-center">
              <Col md={12} className="d-flex">
                <Card className="d-flex ws-card">
                  <Card.Body className="text-right">
                    <Card.Title>{workshop.title}</Card.Title>
                    <Card.Text
                      style={{ border: "1px solid #9f9999", borderRadius: 18 }}>
                      <Row className="mx-0">
                        <Col
                          className="p-3"
                          style={{
                            borderLeft: "1px solid #9f9999",
                          }}>
                          {" "}
                          <Row className="mx-0">ظرفیت: {workshop.capacity}</Row>
                          <Row className="mx-0">
                            نوع کارگاه: {workshop.type.text}
                          </Row>
                        </Col>
                        <Col
                          className="p-3"
                          style={{
                            borderLeft: "1px solid #9f9999",
                          }}>
                          {workshop.meetings.data.length > 1 ? (
                            workshop.meetings.data.map((session, index) => (
                              <Row className="mx-0" key={index}>
                                <p>
                                  جلسه {index + 1}:{" "}
                                  <label>
                                    {session.start_date.year +
                                      "/" +
                                      session.start_date.month +
                                      "/" +
                                      session.start_date.day +
                                      "   " +
                                      session.start_date.hour +
                                      ":" +
                                      ("0" + session.start_date.minute).slice(
                                        -2,
                                      )}
                                  </label>
                                  {" تا "}
                                  <label>
                                    {session.finish_date.hour +
                                      ":" +
                                      ("0" + session.finish_date.minute).slice(
                                        -2,
                                      )}
                                  </label>
                                </p>
                              </Row>
                            ))
                          ) : workshop.meetings.data.length === 1 ? (
                            <Row className="mx-0">
                              <p>
                                جلسه 1:{" "}
                                <label>
                                  {workshop.meetings.data[0].start_date.year +
                                    "/" +
                                    workshop.meetings.data[0].start_date.month +
                                    "/" +
                                    workshop.meetings.data[0].start_date.day +
                                    "   " +
                                    workshop.meetings.data[0].start_date.hour +
                                    ":" +
                                    (
                                      "0" +
                                      workshop.meetings.data[0].start_date
                                        .minute
                                    ).slice(-2)}
                                </label>
                                {" تا "}
                                <label>
                                  {workshop.meetings.data[0].finish_date.hour +
                                    ":" +
                                    (
                                      "0" +
                                      workshop.meetings.data[0].finish_date
                                        .minute
                                    ).slice(-2)}
                                </label>
                              </p>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col className="p-3">
                          <Row className="mx-0">
                            قیمت:
                            {workshop.offered_fee === workshop.fee ? (
                              <b>{workshop.fee} تومان</b>
                            ) : (
                              <p>
                                <del style={{ color: "red" }}>
                                  {workshop.fee} تومان
                                </del>
                                <br />
                                <b>{workshop.offered_fee} تومان</b>
                              </p>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </Card.Text>

                    {context.ApiDriver.access_token ? (
                      <Col className="cslformcontainer">
                        <Row className="mx-0">
                          <Col md={4}>
                            <FormControl
                              id="first_name"
                              className="pr-4"
                              required
                              placeholder="نام"
                              defaultValue={form_first_name}
                              onChange={e => {
                                set_form_first_name(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="last_name"
                              required
                              className="pr-4"
                              placeholder="نام خانوادگی"
                              defaultValue={form_last_name}
                              onChange={e => {
                                set_form_last_name(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="id_number"
                              required
                              className="pr-4"
                              placeholder="کد ملی"
                              onChange={e => {
                                set_id_number(e.target.value);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col md={4}>
                            <FormControl
                              id="university"
                              required
                              className="pr-4"
                              placeholder="نام دانشگاه"
                              onChange={e => {
                                set_form_university(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="grade"
                              required
                              className="pr-4"
                              placeholder="مقطع تحصیل"
                              onChange={e => {
                                set_form_grade(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="field"
                              required
                              className="pr-4"
                              placeholder="رشته تحصیل"
                              onChange={e => {
                                set_form_field(e.target.value);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col md={4}>
                            <FormControl
                              id="email"
                              required
                              className="pr-4"
                              placeholder="ایمیل"
                              defaultValue={form_email}
                              onChange={e => {
                                set_form_email(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="phone"
                              required
                              className="pr-4"
                              placeholder="شماره تماس"
                              onChange={e => {
                                set_form_phone(e.target.value);
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <FormControl
                              id="job"
                              required
                              className="pr-4"
                              placeholder="شغل"
                              onChange={e => {
                                set_form_job(e.target.value);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col md={8}>
                            <Form.Group>
                              <Form.Control
                                id="address"
                                required
                                as="textarea"
                                rows="3"
                                onChange={e => {
                                  set_form_address(e.target.value);
                                }}
                                placeholder="محل سکونت"
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Row className="mx-0">
                              <label for="birth_date">تاریخ تولد:</label>
                              <InputGroup id="birth_date">
                                <Col md={4}>
                                  <FormControl
                                    min="1"
                                    max="31"
                                    type="number"
                                    required
                                    placeholder="روز"
                                    onChange={e => {
                                      set_form_birth_date_day(e.target.value);
                                    }}
                                  />
                                </Col>
                                <Col md={4}>
                                  <FormControl
                                    min="1"
                                    max="12"
                                    type="number"
                                    required
                                    placeholder="ماه"
                                    onChange={e => {
                                      set_form_birth_date_month(e.target.value);
                                    }}
                                  />
                                </Col>
                                <Col md={4}>
                                  <FormControl
                                    min="1300"
                                    max="1400"
                                    type="number"
                                    required
                                    placeholder="سال"
                                    onChange={e => {
                                      set_form_birth_date_year(e.target.value);
                                    }}
                                  />
                                </Col>
                              </InputGroup>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col>
                            <Row className="justify-content-end mx-0">
                              <Button
                                bsPrefix="custom-button"
                                disabled={requesting}
                                onClick={registerWorkShop}
                                style={{ fontSize: 14 }}>
                                {requesting ? "..." : "ثبت سفارش"}
                              </Button>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      <Col>
                        <Row className="mx-0">
                          <h3>
                            لطفا جهت ثبت نام در کارگاه{" "}
                            <a
                              href={`https://core.pajoohyar.ir/inoor/login?context=2&data=${JSON.stringify(
                                {
                                  redirect_url: encodeURI(
                                    document.location.pathname,
                                  ),
                                },
                              )}`}>
                              وارد
                            </a>{" "}
                            شوید.
                          </h3>
                        </Row>
                      </Col>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        ""
      )}
    </DocumentMeta>
  );
};

export default WorkShopRegister;
